import {
    RoutingRuleBillAggregationType,
    RoutingRuleOrderItemConsumptionPeriodType,
    RoutingRuleTriggerType,
} from '@mews-commander/data-access';
import { RoutingRulesFormStepName, TimingFieldName } from './types';
import { ItemsAndConditionsFormFields, RoutingRuleFormValues, TargetBillFormFields, TargetBillType } from './schemas';

export const stepOrder: RoutingRulesFormStepName[] = [
    RoutingRulesFormStepName.Timing,
    RoutingRulesFormStepName.ItemsAndConditions,
    RoutingRulesFormStepName.TargetBill,
    RoutingRulesFormStepName.Summary,
] as const;

export const defaultValues: RoutingRuleFormValues = {
    [RoutingRulesFormStepName.Timing]: {
        [TimingFieldName.Name]: '',
        [TimingFieldName.Description]: '',
        [TimingFieldName.TriggerTiming]: RoutingRuleTriggerType.Continuous,
        [TimingFieldName.TriggerDay]: 1,
        [TimingFieldName.ConsumptionDate]: RoutingRuleOrderItemConsumptionPeriodType.SameMonth,
    },
    [RoutingRulesFormStepName.ItemsAndConditions]: {
        [ItemsAndConditionsFormFields.Services]: {},
        [ItemsAndConditionsFormFields.AdditionalServices]: {},
        [ItemsAndConditionsFormFields.Companies]: {},
        [ItemsAndConditionsFormFields.RatesEnabled]: false,
        [ItemsAndConditionsFormFields.CompaniesEnabled]: false,
        [ItemsAndConditionsFormFields.PrepaidReservationsEnabled]: false,
    },
    [RoutingRulesFormStepName.TargetBill]: {
        [TargetBillFormFields.TargetType]: TargetBillType.CompanyBill,
        [TargetBillFormFields.AggregationType]: RoutingRuleBillAggregationType.AggregateAll,
        [TargetBillFormFields.IncludeCompanyDetails]: [] as string[],
    },
} as const;
